// Convert a publisher name to a URL-safe slug.
// Lowercase, strip diacritics (æ→ae, ø→oe, å→aa), replace non-alphanumerics with hyphens.
export function publisherToSlug(name: string): string {
  if (!name) return '';
  const lower = name.trim().toLowerCase();
  const replaced = lower
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/å/g, 'aa');
  const ascii = replaced.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  return ascii
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Normalize a publisher for grouping (case + whitespace insensitive).
export function normalizePublisher(name: string): string {
  return (name || '').trim().toLowerCase();
}
